class Integrations {
  constructor(component) {
    this.component = component;
    this.triggers = component.querySelectorAll(
      "[data-integrations-dropdown-btn]"
    );
    this.columns = component.querySelectorAll("[data-integrations-column]");
    this.animationStripeElement = component.querySelector(
      "[data-integrations-animation-stripe]"
    );
    this.animationEllipseElements = component.querySelectorAll(
      "[data-integrations-animation-ellipse]"
    );

    // Handle window resizing and initial setup
    this.updateEventListeners();
    window.addEventListener("resize", this.updateEventListeners.bind(this));
  }

  updateEventListeners() {
    if (window.innerWidth <= 991) {
      this.addEventListeners();
      this.addAccessibilityAttributes();
    } else {
      this.removeEventListeners();
      this.removeAccessibilityAttributes();
      this.resetColumns();
      this.setAnimationProperties();
    }
  }

  addAccessibilityAttributes() {
    this.triggers.forEach((trigger) => {
      trigger.setAttribute("role", "button");
      trigger.setAttribute("tabindex", "0");
    });
  }

  removeAccessibilityAttributes() {
    this.triggers.forEach((trigger) => {
      trigger.removeAttribute("role");
      trigger.removeAttribute("tabindex");
    });
  }

  addEventListeners() {
    this.triggers.forEach((trigger, index) => {
      if (!trigger.dataset.hasListeners) {
        trigger.addEventListener("click", () => this.toggleColumn(index));
        trigger.dataset.hasListeners = "true";

        // Initialize aria-expanded as false when listeners are added
        this.columns[index].setAttribute("aria-expanded", "false");
      }
    });
  }

  removeEventListeners() {
    this.triggers.forEach((trigger, index) => {
      if (trigger.dataset.hasListeners) {
        trigger.removeEventListener("click", () => this.toggleColumn(index));
        trigger.dataset.hasListeners = "false";
      }
    });
  }

  resetColumns() {
    // Remove active class and aria-expanded attribute from all columns on desktop
    this.columns.forEach((column) => {
      column.classList.remove("active");
      column.removeAttribute("aria-expanded");
    });
  }

  toggleColumn(index) {
    const column = this.columns[index];
    const isActive = column.classList.toggle("active");
    column.setAttribute("aria-expanded", isActive ? "true" : "false");
  }

  setAnimationProperties() {
    const containerWidth = this.animationStripeElement.offsetWidth;
    const ellipseWidth = this.animationEllipseElements[0].offsetWidth;
    // Start off-screen
    const start = -ellipseWidth;
    // End off-screen
    const end = containerWidth;

    // Set CSS variables
    this.component.style.setProperty(
      "--integrations-animation-start-translate",
      `${start}px`
    );
    this.component.style.setProperty(
      "--integrations-animation-end-translate",
      `${end}px`
    );

    this.animationEllipseElements.forEach((ellipse) => {
      // Randomize animation delay between -15s and 0s
      const randomDelay = -Math.random() * 15;
      // Randomize animation duration between 10s and 20s
      const randomDuration = 10 + Math.random() * 10;
      // Randomize vertical position between 0% and 50%
      const randomBottom = Math.random() * 50;

      // Set inline styles with the random values
      ellipse.style.animationDelay = `${randomDelay}s`;
      ellipse.style.animationDuration = `${randomDuration}s`;
      ellipse.style.bottom = `${randomBottom}%`;
    });
  }
}

document.querySelectorAll("[data-integrations]").forEach((component) => {
  new Integrations(component);
});
